// @react/hooks/useContext.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { contextStore } from '@core/stores';

/**
 * React hook for AspectTypeManifest operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useContext } from '@react/hooks';
 *
 * const AspectTypeManifestList = observer(() => {
 *   const store = useContext();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useContext() {
  return contextStore;
}
